module.exports = __webpack_public_path__ + "img/interreg.4dfd4247.png";